import React from "react";
import PropTypes from "prop-types";
import MapContainer from "../../utilities_dashboard/map/MapContainer";

class App extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <MapContainer currentType={"sheet_utilities_total"} countries={this.props.data.utilities_nr} selectFromMap={function () {}} selectedCountryCode={"all"} />
      </div>
    );
  }
}

App.propTypes = {
  data: PropTypes.shape({
    utilities_nr: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

export default App;
